export default __webpack_public_path__ + "static/media/assassin_color.f124dfd4.png";